export const writingPrompts = [
  {
    id: 1,
    title: "Technology in Education",
    type: "Independent Writing Task",
    timeLimit: 30,
    minWords: 300,
    prompt: "Some educators believe that digital technology should be used extensively in university classrooms, while others think traditional teaching methods are more effective. Which approach do you think is better for students' learning and why?",
    requirements: {
      minWords: 300,
      timeLimit: 30,
      keyPoints: [
        "Clear thesis statement",
        "Specific examples",
        "Personal experience",
        "Logical organization"
      ]
    },
    tips: [
      "Use specific examples to support your position",
      "Consider both advantages and disadvantages",
      "Include personal experiences if relevant",
      "Follow clear essay structure (intro, body, conclusion)"
    ]
  },
  {
    id: 2,
    title: "Urban vs Rural Living",
    type: "Independent Writing Task",
    timeLimit: 30,
    minWords: 300,
    prompt: "Some people prefer to live in rural areas, while others choose to live in urban cities. Which setting do you prefer and why? Use specific reasons and examples to support your answer.",
    requirements: {
      minWords: 300,
      timeLimit: 30,
      keyPoints: [
        "Clear preference stated",
        "Multiple supporting reasons",
        "Specific examples",
        "Comparative analysis"
      ]
    },
    tips: [
      "Compare and contrast both options",
      "Use concrete examples",
      "Consider multiple aspects (work, lifestyle, education)",
      "Address potential counterarguments"
    ]
  },
  {
    id: 3,
    title: "Learning Methods",
    type: "Independent Writing Task",
    timeLimit: 30,
    minWords: 300,
    prompt: "Some students prefer to learn by doing hands-on activities, while others prefer to learn by reading about topics in books. Which approach do you think is more effective for learning new concepts and why?",
    requirements: {
      minWords: 300,
      timeLimit: 30,
      keyPoints: [
        "Learning style analysis",
        "Supporting evidence",
        "Real-world applications",
        "Educational outcomes"
      ]
    },
    tips: [
      "Use educational examples",
      "Include personal learning experiences",
      "Consider different subjects",
      "Discuss long-term retention"
    ]
  },
  {
    id: 4,
    title: "Environmental Protection",
    type: "Independent Writing Task",
    timeLimit: 30,
    minWords: 300,
    prompt: "Some people believe individuals should be responsible for environmental protection, while others think governments should take the primary role. Which view do you support and why?",
    requirements: {
      minWords: 300,
      timeLimit: 30,
      keyPoints: [
        "Responsibility analysis",
        "Implementation methods",
        "Practical examples",
        "Impact assessment"
      ]
    },
    tips: [
      "Consider both individual and governmental roles",
      "Provide specific environmental examples",
      "Discuss feasibility",
      "Address resource allocation"
    ]
  },
  {
    id: 5,
    title: "Cultural Preservation",
    type: "Independent Writing Task",
    timeLimit: 30,
    minWords: 300,
    prompt: "In an increasingly globalized world, some people think it's crucial to preserve traditional cultures, while others believe adaptation to modern ways is more important. Which view do you support and why?",
    requirements: {
      minWords: 300,
      timeLimit: 30,
      keyPoints: [
        "Cultural significance",
        "Modern challenges",
        "Balance assessment",
        "Future implications"
      ]
    },
    tips: [
      "Use specific cultural examples",
      "Consider economic factors",
      "Discuss generational perspectives",
      "Address globalization impact"
    ]
  },
  {
    id: 6,
    title: "Social Media Impact",
    type: "Independent Writing Task",
    timeLimit: 30,
    minWords: 300,
    prompt: "Some people believe social media has improved communication and relationships, while others think it has made them more superficial. Which view do you agree with and why?",
    requirements: {
      minWords: 300,
      timeLimit: 30,
      keyPoints: [
        "Communication analysis",
        "Relationship quality",
        "Social impact",
        "Technology effects"
      ]
    },
    tips: [
      "Include personal experiences",
      "Consider different age groups",
      "Discuss privacy aspects",
      "Address mental health impacts"
    ]
  },
]; 